module.exports = __webpack_public_path__ + "img/a21f934.jpg";